import {
  LitElement,
  html,
} from '@hh/global.js'

class VisualFilter extends LitElement {

  constructor() {
    super()
    this.buttons = this.querySelectorAll('hh-draggable-slider .visual-fiter__card > a')
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleFilterClick()
  }

  handleFilterClick() {
    this.buttons?.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        const collectionLink = button.dataset.link;
        const isCollectionTitle = button.dataset.collectionTitle;
        const collectionTitle = button.dataset.title;

        const navigationChangeEvent = new CustomEvent('navigation:change', {
          detail: {
            link: collectionLink,
            isTitle: Boolean(isCollectionTitle === 'true'),
            title: collectionTitle
          },
        })
        window.dispatchEvent(navigationChangeEvent);
      })
    });
  }


  render() {
    return html` <slot></slot>`
  }

}
customElements.define('visual-filter', VisualFilter)
